import { useForm } from "../../hooks/useForm"
import './member-form.css'
import Input from "../../blocks/Input"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { ajax } from "../../scripts/helper"
import utils from "../../scripts/utils"
import { useSnackbar } from "notistack"
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';


const MemberForm = ({type, state}) => {
    const {enqueueSnackbar} = useSnackbar()
    const navigate = useNavigate()
    const [readOnly, setReadOnly] = useState(false)

    const [rolesOption, setRolesOption] = useState([])
    const [roleValue, setRoleValue] = useState([])

    const [productsOption, setproductsOption] = useState([])
    const [productValue, setProductValue] = useState([])

    const [officeValue, setOfficeValue] = useState()
    const [inputOfficeValue, setInputOfficeValue] = useState('');
    const [officeOptions, setOfficeOptions] = useState([]);

    const [inputFields, handleChange, setInputFields] = useForm({
        name: {
            name: 'name',
            value: "",
            type: "text",
            placeholder: "name..."
        },
        username: {
            name: 'username',
            value: "",
            type: "text",
            placeholder: "username"
        },
        role: {
            name: "role",
            value: "",
            type: "select",
            selected: null,
            items: []
        },
        email: {
            name: "email",
            value: "",
            type: "text",
            placeholder: "me@example.com"
        },
        mobile: {
            name: "mobile",
            value: "",
            type: "text",
            placeholder: "+98 9** ****"
        },
        code: {
            name: "code",
            value: "",
            type: "select",
            selected: null,
            items: []
        },
        password: {
            name: "password",
            value: "",
            type: "password",
            placeholder: "**** ****"
        },
        status: {
            name: 'status',
            value: '',
            type: 'select',
            selected: null,
            items:[
                {label:'ACTIVE', data: {label: 'ACTIVE'}},
                {label: 'INACTIVE', data: {label: 'INACTIVE'}},
                {label: 'PENDING', data: {label: 'PENDING'}},
                {label: 'DELETED', data: {label: 'DELETED'}},
            ]
        }

    })

    const getUserDetail = async() => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.userDetail(state.id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if(!res) return


        fillData(res.data)
    }

    const fillData = (detail) => {
        setInputFields({
            ...inputFields,
            name: {
                ...inputFields.name,
                value: detail.name
            },
            username: {
                ...inputFields.username,
                value: detail.username
            },
            email: {
                ...inputFields.email,
                value: detail.email
            },
            mobile: {
                ...inputFields.mobile,
                value: detail.mobile
            },
            code: {
                ...inputFields.code,
                value: detail.office,
                selected: detail?.office?.id
            },
            status: {
                ...inputFields.status,
                value: detail.status
            }
        })
        setRoleValue(detail.roles)
        setProductValue(detail.products)
    }

    const fetchRoles = async () => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.roleList,
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!res) return

        setRolesOption(res.data.content)
    }

    const fetchProducts = async() => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.productList,
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!res) return 

        setproductsOption(res.data)
    }


    const fetchOffice = async () => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.searchOfficeByCode(inputOfficeValue),
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!res) return

        setOfficeOptions(res.data)
    }

    useEffect( () => {
        if(type === 'edit' || type === 'detail'){
            getUserDetail(state)
            if(type === 'detail') setReadOnly(true)
            if(type === 'edit') {
                fetchRoles()
                fetchProducts()
            }
        }
        if(type === 'create') {
            fetchRoles()
            fetchProducts()
        }
    },[])


    useEffect( () => {
        if(inputOfficeValue.trim()) fetchOffice()

     }, [inputOfficeValue])



    const createUser = async () => {
        let roles = []
        for (const role of roleValue) {
            roles.push(role.id)
        }
        let products = []
        for(const product of productValue){
            products.push(product.id)
        }
        let body = {
            "username": inputFields.username.value,
            "name": inputFields.name.value,
            "password": inputFields.password.value,
            "email": inputFields.email.value,
            "mobile": inputFields.mobile.value,
            "status": "ACTIVE",
            "roles": roles,
            "products": products,
            "officeId": inputFields.code.selected
        }

        console.log(body , ' this is body of req')

        const res = await ajax({
            method: 'POST',
            url: utils.urls.createUser,
            snackbar: enqueueSnackbar,
            hasToken: true,
            data: body
        })

        if(!res) return

        navigate('/agent/users')
        console.log(res.data)
    }


    const updateUser = async () => {
        let roles = []
        for (const role of roleValue) {
            roles.push(role.id)
        }
        let products = []
        for(const product of productValue){
            products.push(product.id)
        }
        
        let body = {
            "username": inputFields.username.value,
            "name": inputFields.name.value,
            "email": inputFields.email.value,
            "mobile": inputFields.mobile.value,
            "status": (inputFields.status.value === state.status ? inputFields.status.value : inputFields.status.value.label),
            "roles": roles,
            "products": products,
            "officeId": inputFields.code.selected,
        }
        if(inputFields.password.value.trim()) {
            body.password = inputFields.password.value
        }

        const res = await ajax({
            method: 'PUT',
            url: utils.urls.updateUser(state.id),
            snackbar: enqueueSnackbar,
            hasToken: true,
            data: body
        })

        if(!res) return

        navigate('/agent/users')
        console.log(res.data)
    }

    const saveButton = () => {
        if(type === 'create') createUser()

        if(type === 'edit') updateUser()

    }


    return (
        <>
            <div className="user-form-container__inputs">
                <div className="row">
                    <div className="officeId">
                        <label>Name</label>
                        <Input
                        className="extra"
                        inputField={inputFields.name}
                        onChange={handleChange}
                        readOnly={readOnly}
                        />
                    </div>
                    <div className="officeCode">
                        <label>Username</label>
                        <Input
                        className="extra"
                        inputField={inputFields.username}
                        onChange={handleChange}
                        readOnly={readOnly}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="officeId">
                        <label>Email</label>
                        <Input
                        className="extra"
                        inputField={inputFields.email}
                        onChange={handleChange}
                        readOnly={readOnly}
                        />
                    </div>
                    <div className="officeCode">
                        <label>Mobile</label>
                        <Input
                        className="extra"
                        inputField={inputFields.mobile}
                        onChange={handleChange}
                        readOnly={readOnly}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="officeId">
                    <label>Office</label>
                        <Autocomplete 
                            sx={{ width: "100%" }}
                            renderInput={(params) => <TextField {...params} />}
                            getOptionLabel={ (option) =>  option ? option.code : ''}
                            options={officeOptions}
                            autoComplete
                            includeInputInList
                            filterSelectedOptions
                            value={inputFields.code.value}
                            noOptionsText="No office"
                            onChange={(event, newValue) => {
                                setOfficeValue(newValue?.id);
                                console.log(newValue, ' new valueeee')
                                setInputFields({
                                    ...inputFields,
                                    code: {
                                        ...inputFields.code,
                                        selected: newValue?.id,
                                        value: newValue
                                    }
                                })
                                console.log(newValue)
                            }}
                            onInputChange={(event, newInputValue) => {
                                if(newInputValue.trim())
                                    setInputOfficeValue(newInputValue)
                            }}
                            renderOption={(props, option) => <li {...props}>{option.code}</li>}
                            readOnly={readOnly}

                        />
                    </div>
                    {
                        type !== 'detail' &&
                        <div className="officeCode">
                            <label>Password</label>
                            <Input
                            className="extra"
                            inputField={inputFields.password}
                            onChange={handleChange}
                            />
                        </div>
                    }
                </div>
                
                <div className="row">
                    <div className="officeId">
                    <label>Products</label>
                        <Autocomplete
                        multiple
                        id="tags-outlined"
                        options={productsOption}
                        getOptionLabel={(option) => option.name}
                        // defaultValue={[]}
                        value={productValue}
                        filterSelectedOptions
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            />
                        )}
                        onChange={(event , newValue) => {
                            console.log(event , 'lllll', newValue)
                            setProductValue(newValue)
                        }}
                        readOnly={readOnly}

                        />
                    </div>
                    <div className="officeCode">
                    <label>Status</label>
                        <Autocomplete
                            id="tags-outlined"
                            options={inputFields.status.items}
                            // getOptionLabel={(option) => (type === 'edit' ? option.name :)}
                            // defaultValue={[]}
                            value={inputFields.status.value}
                            filterSelectedOptions
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                />
                            )}
                            onChange={(event , newValue) => {
                                console.log(event , 'lllll', newValue)
                                setInputFields({
                                    ...inputFields,
                                    status: {
                                        ...inputFields.status,
                                        value: newValue
                                    }
                                })
                            }}
                            readOnly={readOnly}
                            disableCloseOnSelect

                        />
                        
                    </div>
                </div>
                <div className="row">
                    <div className="officeId">
                    <label>Role</label>
                        <Autocomplete
                            multiple
                            id="tags-outlined"
                            options={rolesOption}
                            getOptionLabel={(option) => option.name}
                            // defaultValue={[]}
                            value={roleValue}
                            filterSelectedOptions
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                />
                            )}
                            onChange={(event , newValue) => {
                                console.log(event , 'lllll', newValue)
                                setRoleValue(newValue)
                            }}
                            readOnly={readOnly}

                        />
                    </div>
                </div>
                
            </div>
            {
                type !== 'detail' &&
                <div className="member-edit-btn">
                    <button className="delete" onClick={() => navigate('/agent/users')}>Back</button>
                    <button className="save" onClick={() => saveButton()}>{(type==='edit' ? 'Save changes' : 'Create')}</button>
                </div>
            }
            {
                type === 'detail' &&
                <div className="member-edit-btn">
                    <button className="back" onClick={() => navigate('/agent/users')}>Back</button>
                </div>
            }
        </>
    )
}
export default MemberForm